import { Component, OnInit } from '@angular/core';
import { SidebarService } from '@ibe/services/ui';
import { Router, ActivatedRoute } from '@angular/router';
import { ChangeFlightService } from '@ibe.services/change-flight.service';

@Component({
	selector: 'app-shopping-basket',
	templateUrl: './shopping-basket.component.html',
	styleUrls: ['./shopping-basket.component.scss']
})
export class ShoppingBasketComponent implements OnInit {
	selectedFlights: any = [];

	constructor(
		protected sidebarService: SidebarService,
		protected route: ActivatedRoute,
		protected router: Router,
		private changeFlightbService: ChangeFlightService
	) {}

	ngOnInit() {
		this.selectedFlights = this.changeFlightbService.getSelectedFlights();
	}

	// SIDEBAR INTERACTIONS

	/** Close sidebar and clear secondary route */
	private closeSidebar() {
		this.sidebarService.closeSidebar();
		this.router.navigate([{ outlets: { sidebar: null } }], { replaceUrl: true });
	}

	/** Handles close action intention **/
	TAP_handleClose() {
		this.closeSidebar();
	}
}
